import { Component, Input } from '@angular/core';
import { Customer } from '../../models/customer';
import { GungModalService } from '../../services/gung-modal/gung-modal.service';

@Component({
  selector: 'lib-return-warranty-customer-details-wrapper',
  templateUrl: './return-warranty-customer-details-wrapper.component.html',
  styleUrl: './return-warranty-customer-details-wrapper.component.scss',
  standalone: false
})
export class ReturnWarrantyCustomerDetailsWrapperComponent {
  @Input() customer: Customer;

  constructor(
    protected gungModalService: GungModalService
  ) {}

  openCreateWarrantyModal() {
    this.gungModalService.openViewCreateReturnWarrantyModal().then(
      result => { },
      reason => { }
    );
  }
}
